import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from "vue-router";

import routes from "./routesList.js"

const router = createRouter({
	history: createWebHashHistory(),
	routes
})


export default router;
